import Quill from 'quill';
export const CELL_MIN_WIDTH = 50;
export const ROW_MIN_HEIGHT = 24;
export const HANDLE_CENTER_OFFSET = 4; // half of handle width/height (8px) to center on border
export const QUILL_BETTER_TABLE_REFLOW_DELAY = 50; // ms — wait for quill-better-table deferred width updates
// CSS class names — single source of truth shared between SCSS and TypeScript
export const CSS_TABLE_TOOLBAR = 'aq-table-toolbar';
export const CSS_TABLE_TOOLBAR_BUTTON = 'aq-table-toolbar__btn';
export const CSS_TABLE_TOOLBAR_BUTTON_DANGER = 'aq-table-toolbar__btn--danger';
export const CSS_TABLE_TOOLBAR_SEPARATOR = 'aq-table-toolbar__separator';
export const CSS_COLUMN_RESIZE_HANDLE = 'aq-col-resize-handle';
export const CSS_COLUMN_RESIZE_HANDLE_ACTIVE = 'aq-col-resize-handle--active';
export const CSS_ROW_RESIZE_HANDLE = 'aq-row-resize-handle';
export const CSS_ROW_RESIZE_HANDLE_ACTIVE = 'aq-row-resize-handle--active';
export const CSS_SELECTION_LINE = 'qlbt-selection-line';
export const DATA_WEEK_OVERVIEW = 'data-week-overview';
export const CSS_WEEK_OVERVIEW_TABLE = 'table--week-overview';
/**
 * Returns the bounding rect of the actual cell content rather than the
 * <table> element's CSS box (which may be wider due to `width: 100%`).
 */
export function getTableContentRect(table) {
    const rows = table.querySelectorAll('tr');
    if (rows.length === 0)
        return table.getBoundingClientRect();
    const firstRow = rows[0];
    const lastRow = rows[rows.length - 1];
    const cells = firstRow.querySelectorAll('td');
    if (cells.length === 0)
        return table.getBoundingClientRect();
    const firstCellRect = cells[0].getBoundingClientRect();
    const lastCellRect = cells[cells.length - 1].getBoundingClientRect();
    const lastRowRect = lastRow.getBoundingClientRect();
    return {
        top: firstCellRect.top,
        left: firstCellRect.left,
        width: lastCellRect.right - firstCellRect.left,
        height: lastRowRect.bottom - firstCellRect.top,
    };
}
/**
 * Redistributes column widths so they sum exactly to the editor's content width.
 * Columns get equal shares; remainder pixels go to the last column.
 */
export function getEditorContentWidth(editor) {
    const root = editor.root;
    const style = window.getComputedStyle(root);
    return root.clientWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);
}
export function redistributeColumnWidths(editor, table, targetWidth) {
    const editorWidth = targetWidth || getEditorContentWidth(editor);
    if (editorWidth <= 0)
        return;
    const tableContainer = Quill.find(table);
    if (!tableContainer || !tableContainer.colGroup)
        return;
    const colGroup = tableContainer.colGroup();
    if (!colGroup || !colGroup.children || colGroup.children.length === 0)
        return;
    const colCount = colGroup.children.length;
    const baseWidth = Math.floor(editorWidth / colCount);
    const remainder = editorWidth - baseWidth * colCount;
    colGroup.children.forEach((colBlot, index) => {
        const width = index === colCount - 1 ? baseWidth + remainder : baseWidth;
        colBlot.format('width', width);
    });
    if (tableContainer.updateTableWidth) {
        tableContainer.updateTableWidth();
    }
}
